import { NominationRole } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateAwardNominationRole: (
  fetchContext: FetchContext,
  awardId: number,
  nominationId: number,
  nominationRole: NominationRole,
  accessToken?: string,
) => Promise<void> = async (fetchContext, awardId, nominationId, nominationRole, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/awards/${awardId}/nominations/${nominationId}/role`,
  {
    method: 'PUT',
    body: JSON.stringify(nominationRole),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update award nomination role'));
